import * as Modal from "../../atoms/CommonModalPopup";
import warningIcon from "../../../images/warning.svg";
import DRAFTICON from "../../../images/drafticon.svg";
import { useEffect, useState } from "react";


function CommonModalPopup(props) {
    const {type,title,body,confirm,cancel,close,show=false,bodycomp=false,showIcon=true} = props;
    const [showModal, setShowModal] = useState(show)
    
    const onClose = () =>{
        if(close?.handler && typeof close?.handler === "function"){close?.handler()}
        setShowModal(false)
    }

    const onCancel = () =>{
        if(cancel?.handler && typeof cancel?.handler === "function"){cancel?.handler()}
        if(cancel?.autoclose !== undefined){
            cancel?.autoclose && setShowModal(false)
        }
        else{
            setShowModal(false)
        }
    }
    const onSubmit = () =>{
        if(confirm?.handler && typeof confirm?.handler === "function"){confirm?.handler()}
        setShowModal(false)
    }

    const popupIcon = ()=>{
        if(type==="message") {return DRAFTICON} else{return warningIcon}
    }
    useEffect(()=>{
        setShowModal(show);
    },[show]);

    return (
        <>
        {showModal && 
                <>
                <Modal.ModalPopupBG onClick={close?.handler}/>
                    <Modal.ModalPopupWrapper select={props?.selectCountry || props?.logout}>
                        <Modal.ModalPopupHeader>
                        <Modal.ModalPopupTitle>{title}</Modal.ModalPopupTitle>
                        {close && <Modal.ModalCloseButton onClick={onClose}/>}
                        </Modal.ModalPopupHeader>
                        <Modal.ModalPopupBody>
                        {showIcon && <Modal.ModalPopupIcon>
                            <img src={popupIcon()} alt="warningIcon"/>
                        </Modal.ModalPopupIcon>}
                        {
                            bodycomp?
                            <Modal.ModalPopupText >{body}</Modal.ModalPopupText>
                            :
                            <Modal.ModalPopupText  dangerouslySetInnerHTML={{__html: body}}></Modal.ModalPopupText>

                        }
                        </Modal.ModalPopupBody>
                        <Modal.ModalPopupFooter>
                    {confirm?.title && <Modal.YesButton
                            onClick={onSubmit}>
                            <span>{confirm?.title}</span>
                        </Modal.YesButton>}
                        {cancel?.title && <Modal.NoButton
                            onClick={onCancel}>
                            {cancel?.title}
                        </Modal.NoButton>}
                        </Modal.ModalPopupFooter>
                    </Modal.ModalPopupWrapper>
                </>
        }            
        </>
);}

export default CommonModalPopup;